<template>
  <div>
    <el-select
      ref="agSelect"
      v-model="agValue"
      v-bind="componentProps"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
    >
      <el-option v-for="item in options" :key="item[optionKey]" v-bind="getOptionsProps(item)" />
    </el-select>
  </div>
</template>

<script>

import agEditorMixins from './ag-editor-mixins'
export default {
  name: 'AgGridSelect',
  mixins: [agEditorMixins],
  data() {
    return {
      options: []
    }
  },
  computed: {
    optionKey() {
      const { config } = this.componentProps
      const { value } = config || {}

      return value || 'sCodeValue'
    },
    componentProps() {
      return Object.assign(
        {},
        {
          placeholder: this.$t('components.pleaseEnter'),
          size: 'mini',
          hasInitChange: true
        },
        this.params?.cellEditorComponentProps || {}
      )
    }
  },
  created() {
    const { queryMethod, hasInitChange, autoFocus } = this.componentProps

    queryMethod?.(this.params).then((options) => {
      this.options = options
      this.$nextTick(() => {
        this.agValue = this.params.value
        if (autoFocus) {
          this.focus()
        }
        if (hasInitChange) {
          this.handleChange(this.agValue, 'init')
        }
      })
    })
  },
  methods: {
    triggerChange(records, type) {
      const { cellEditorComponentProps, ...restAgParams } = this.params

      const { change } = cellEditorComponentProps || {}
      change?.(this.agValue, records, { agParams: restAgParams }, type)
    },
    getOptionsProps(record) {
      const { config, getSelectOptionProps } = this.componentProps

      const { label, value } = config || {}

      const textLabel = record[label || 'sCodeName']
      const textValue = record[value || 'sCodeValue']

      return {
        ...record,
        label: textLabel,
        value: textValue,
        ...getSelectOptionProps?.(record)
      }
    },
    focus() {
      this.$refs.agSelect.focus()
    },
    // 聚焦事件触发
    handleFocus(e) {
      this.triggerFocus(e)
    },
    // 失焦事件触发
    handleBlur(e) {
      this.triggerBlur(e)
    },
    handleChange(val, type) {
      const { multiple } = this.componentProps

      if (multiple) {
        const valArr = Array.isArray(val) ? val : [val]

        const records = valArr.length ? this.options.filter(item => {
          const { value } = this.getOptionsProps(item)

          return valArr.includes(value)
        }) : []

        this.triggerChange(records, type)
      } else {
        const record = this.options.find(item => {
          const { value } = this.getOptionsProps(item)
          return val === value
        })
        this.triggerChange(record, type)
      }
    }
  }
}
</script>
